import React from "react";
import { Modal } from "react-bootstrap";
import videoLink from "../../assets/video/dashboardVideo1.mp4";

export const VideoModalDashboard = ({ show, handleClose }) => {
  return (
    <Modal size="lg" show={show} onHide={handleClose} centered>
      <Modal.Body>
        <div className="otpModalMain broadcastModal">
          <div className="closeIcon" onClick={handleClose}>
            <i className="fa-solid fa-xmark" />
          </div>

          <div className="mt-3">
            {/* <img src={broadCastIco} alt="" /> */}
            <video
              playsInline
              webkit-playsinline
              controls={true}
              src={videoLink}
              autoPlay
              loop
              // muted
              className="w-100"
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
